// extracted by mini-css-extract-plugin
export default {"wrapper":"mKal5","item":"LOpUy"};